import React from "react";
import './index.scss';

const ChartValueCount = (data) => {

	return (
		<>
			<div className="chart-msg-blc d-flex flex-column align-items-center justify-content-center">
				<div className="msg d-inline-flex align-items-center">
					<span className="icon d-flex flex-column align-items-center justify-content-center">
						<img className="img-fluid" src={require('../../../../../../assets/img/doc-icon.png')} alt="Document" />
					</span>
					<span className="txt">
						{data.data[0].numberOfPackets ? data.data[0].numberOfPackets : (data.data[0].numberOfFiles ? data.data[0].numberOfFiles : (data.data[0].totalEditedFilesCount? data.data[0].totalEditedFilesCount : data.data[0].numberOfProcessPackets))}
						<span className="d-block">
							{data.data[0].numberOfPackets ? (data.data[0].numberOfPackets==1 ?"Packet":"Packets" ): (data.data[0].numberOfProcessPackets ?(data.data[0].numberOfProcessPackets==1 ?"Packet":"Packets") :(data.data[0].numberOfFiles==1 ? "Doc":"Docs"))} in {data.data[0]._id}
						</span>
					</span>
				</div>
			</div>
		</>
	);

}
export default ChartValueCount;